module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av604-5a51688cc8a81730b0a85886181c6b2b.jpg";